import { render, staticRenderFns } from "./ProfitLossDashboardPage.vue?vue&type=template&id=2efd867f&scoped=true&"
import script from "./ProfitLossDashboardPage.vue?vue&type=script&lang=js&"
export * from "./ProfitLossDashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./ProfitLossDashboardPage.vue?vue&type=style&index=0&id=2efd867f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efd867f",
  null
  
)

export default component.exports